import React from 'react'

//import * as flightInfoTypes from './flightInfoTypes'

const StationFilter = (props) => {
            
    //let { flightDetail, type } = props
        
    function className(){
        return (
            ''
        )
    }

    return  (
        <div className="title">Filter Flights</div>
    )
}

export default StationFilter